import { useMemo } from 'react';

/**
 * Shared "live caption" two-line tail of whatever the coach is currently saying.
 * Splits the latest script into a quieter previous-sentence line and a
 * highlighted current-sentence line so long captions remain readable.
 */

export default function LiveCaption({ script }: { script: string }) {
  const { previous, current } = useMemo(() => splitScriptSentences(script), [script]);
  return (
    <div className="caption" aria-live="polite">
      {previous && <p className="caption__prev">{previous}</p>}
      <p className="caption__cur">{current}</p>
    </div>
  );
}

function splitScriptSentences(script: string): {
  previous: string | null;
  current: string;
} {
  const m = script.match(/^(.+?[.!?])\s+(.*)$/s);
  if (!m) return { previous: null, current: script };
  return { previous: m[1] ?? null, current: m[2] ?? '' };
}
